module.exports = require("os");


//////////////////
// WEBPACK FOOTER
// external "os"
// module id = 17
// module chunks = 0